import React from "react"
// import  feature_img1  from "../../images/feature_img_1.png";
import styles from "./styles.module.css";
import FeatureGraphic from "../featureGraphic";
import { StaticQuery } from "gatsby";
import BackgroundImage from "gatsby-background-image";

const FeatureList = React.forwardRef(({imageOnRight=true,feature},ref) => (
    <StaticQuery query={graphql`
      query {
        curve: file(relativePath: { eq: "curve-1.png" }) {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
        dots: file(relativePath: { eq: "F-Pattern.png" }) {
            childImageSharp {
              fluid(quality: 100) {
                ...GatsbyImageSharpFluid_noBase64
              }
            }
        }
      }
    `}
    render={data => {
        const curve = data.curve.childImageSharp.fluid
        const dots = data.dots.childImageSharp.fluid
        return (
            <BackgroundImage 
                className={[styles.feature_box,imageOnRight ? styles.dots : styles.curve].join(" ")}
                fluid={imageOnRight ? dots : curve}
            >
                <div className={["container",styles.featureListContainer].join(" ")} ref={ref}>
                    <div className="row">
                        <div className={["col-lg-7", "mb-4", "mb-md-0", "d-flex", "justify-content-md-center", imageOnRight ? "order-lg-2" : "", "pb-md-4", "pb-lg-0"].join(" ")}>
                            <div className={[styles.feature_img_box,"feature_img_box","col-md-8","col-lg-12"].join(' ')}>
                                <FeatureGraphic type={feature.graphic}/>
                            </div>
                        </div>
                        <div className={["col-lg-5", "pl-md-5"].join(" ")}>
                            <div className={styles.feature_detail}>
                                <h2 className={[styles.featureTitle,'text-md-left', 'text-center'].join(' ')}>
                                  {feature.headline}
                                  {
                                    feature.desktopOnly &&
                                    (
                                      feature.cloudComingSoon
                                      ?
                                      <p className={styles.comingSoon}>
                                        <div>Available on MProfit for Windows Desktop</div>
                                        <div className={styles.comingSoon2}>Coming soon to MProfit Cloud</div>
                                      </p>
                                      :
                                      <p className={styles.comingSoon}>
                                        Available on MProfit for Windows Desktop
                                      </p>
                                    )
                                  }
                                </h2>
                                <ul>
                                    {
                                        feature.bullets.map((bullet,index) => {
                                          return (
                                            <li key={index}>{bullet}</li>
                                          )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </BackgroundImage>
        )
    }}
    />
))

export default FeatureList
